/** @jsxImportSource @emotion/react */
import React from 'react'
import { GroupCycleForm, GroupCyclePreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/GroupNCycleContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageCycle } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageCycle]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <GroupCycleForm />
        </div>
        <div css={styles.right}>
          <GroupCyclePreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
